"use client";

import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";

const TOAST_TYPES = {
  info: {
    className: "bg-blue-500/90 text-white border-blue-300",
  },

  success: {
    className: "bg-green-500/90 text-white border-green-300",
  },

  error: {
    className: "bg-red-500/90 text-white border-red-300",
  },
};

export const Toast = ({
  message,
  show,
  onClose,

  type = "info",

  duration = 3000,

  className,
}) => {
  useEffect(() => {
    if (!show) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [show, duration, onClose]);

  const toastType = TOAST_TYPES[type] ?? TOAST_TYPES.info;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{
            opacity: 0,
            y: 30,
            scale: 0.95,
          }}
          animate={{
            opacity: 1,
            y: 0,
            scale: 1,
          }}
          exit={{
            opacity: 0,
            y: 20,
            scale: 0.95,
          }}
          transition={{
            duration: 0.25,
          }}
          className={clsx(
            "absolute bottom-4 z-[999999999]",
            "max-w-[80%]",
            "rounded-2xl",
            "border",
            "px-4 py-2",
            "text-center text-sm",
            "shadow-lg",
            "backdrop-blur-sm",
            toastType.className,
            className,
          )}
        >
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
